export const EVENT = {
  REFRESH_ACTIVE_VIEW: 'REFRESH_ACTIVE_VIEW_EVENT',
  SYSTEM_MESSAGE_VERSION: 'SYSTEM_MESSAGE_VERSION_EVENT'
}